import { apiPaths } from '@/services/api/paths';
import { TOrganizationLead } from '@/types/OrganizationLeads.types';
import { api, TCustomAxiosPaginationResponse } from '..';
import { TOrganizationLeadsSortingColumn } from '@/routes/_authenticated/_admin/organization-leads';
import { SUPER_ADMIN_PAGE_SIZE } from '@/constants/numberVars';

export const getAllOrganizationLeads = async (
  page: number,
  filterParams?: { searchText: string },
  sortingColumn?: string,
  sortingDirection?: string,
): Promise<TCustomAxiosPaginationResponse<TOrganizationLead[]>> => {
  let sortBy = '';
  switch (sortingColumn as TOrganizationLeadsSortingColumn) {
    case 'Total # of Submissions':
      sortBy = 'submission_count';
      break;
    case 'Created':
    default:
      sortBy = 'created_at';
      break;
  }

  const params: { limit: number; page: number; sortBy: string; order: string | undefined; search?: string } = {
    limit: SUPER_ADMIN_PAGE_SIZE,
    page,
    sortBy,
    order: sortingDirection,
  };

  if (filterParams?.searchText) params.search = filterParams?.searchText;

  const { data } = await api.get(apiPaths.organizationLeads.root, {
    params,
  });

  return data;
};

export const deleteOrganizationLead = async (orgLeadSlug: string): Promise<string> => {
  const { data } = await api.delete(apiPaths.organizationLeads.bySlug(orgLeadSlug));

  return data.data;
};
